import React, {useContext, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {CommunityContext} from "src/pages/context/Community.context";
import styles from "./CommunityMemberManage.module.css";
import {Dropdown, List, Menu, Skeleton, Tabs} from "antd";
import settingImg from "../../../assets/png/settings.png";
import useFetch, {CachePolicies} from "use-http";
import {getUserData} from "src/service/auth.service";

import Member from "src/pages/chatPage/Content/Chat/Member";
// import RoleAssignPopup from "src/pages/chatPage/CenterContent/Chat/RoleAssignPopup";
import ModalRoleAssign from "src/pages/chatPage/Content/Chat/ModalRoleAssign";
import CenterButton from "src/components/shared/button/CenterButton";

import backIcon from "src/assets/png/comunityIcon/back.png";
import {requestIcon} from "../../Profile/Request/request.utils.props";
import GroupPending from "src/components/Pending/GroupPending";
import {useAppSelector} from "src/hooks";
import {profile} from "src/features/profile/profileSlice";
import RoleAssignPopup from "src/pages/chatPage/Content/Chat/RoleAssignPopup";
import {useNavigate, useParams} from "react-router-dom";
import {pathRoutes} from "../../../props/util.props";

export const promoteRole = {
  admin: "admin",
  owner: "owner",
  removeAdmin: "remove_admin",
  removeFromGroup: "remove_from_group",
  removeMember: "remove_member",
  removeOwner: "remove_owner"
};

const CommunityMemberManage = (props: any) => {
  const { id } = useParams()
  // const { groupID } = props;
  // const appCtx: any = useContext(AppContext);
  
  const myProfile = useAppSelector(profile);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const communityCtx: any = useContext(CommunityContext);
  const [promoteMember, setPromoteMember]: any = useState(null);
  const [search, setSearch] = useState("");
  const [searchedMember, setSearchedMember] = useState([]);
  const [timer, setTimer]: any = useState();
  const { TabPane } = Tabs
  const fakeChatCtx = { promoteMember, setPromoteMember };
  const [groupPendingRequests, setGroupPendingRequests] = useState<any>([]);
  const onDecline = async (txId: string) => {
    await post(`/reject`, { id: txId });
    if (response.ok) {
      setGroupPendingRequests((reqs: any) => reqs.filter((req: any) => {
        return req?.id !== txId
      }));
    }
  }

  const onAccept = async (txId: string) => {
    await post(`/accept`, { id: txId });
    if (response.ok) {
      setGroupPendingRequests((reqs: any) => reqs.filter((req: any) => {
        return req?.id !== txId
      }));
      loadGroupMember();
    }
  }
  const memberFilter: any = useMemo(() => {
    return communityCtx?.members?.filter((member: any) => {
      return member?.user?.username !== getUserData().username;
    });
  }, [communityCtx?.members]);
  const { get, post, response, loading, error } = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v2/groups")
  const apiGroupMember = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v2/groups/members/${id}`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const loadGroupMember = async () => {
    try {
      const membersRes = await apiGroupMember.get();
      communityCtx.setMembers(membersRes?.members);
    } catch (err) {
      console.error(err);
    }
  };
  const getPendingRequest = async (id: string) => {
    const initPendingReq = await get(`pending-request/${id}`)
    setGroupPendingRequests(initPendingReq)
  }

  const me: any = useMemo(() => {
    return communityCtx?.members?.find((member: any) => {
      return member?.user?.username === getUserData().username;
    });
  }, [communityCtx?.members]);

  const handleBack = () => {
    navigate(-1)
    // communityCtx?.setContent("newFeed");
  };

  const handleInvite = () => {
    // communityCtx?.setContent("invite");
    navigate(`${pathRoutes.groupCommunity}/${id}/invite`);
  };

  const handleSearchMembers = (event: any) => {
    const value = event.target.value;
    setSearch(value);
    clearTimeout(timer!);
    setTimer(
      //@ts-ignore
      setTimeout(() => {
        const findMember = memberFilter.filter((member: any) => {
          return member?.user?.firstname?.match(`^${value}`, "i");
        });

        setSearchedMember(findMember);
      }, 500)
    );
  };

  const handlePromoteMember = (role: string) => {
    setPromoteMember(role);
  };
  useEffect(() => {
    if (!id) return;
    getPendingRequest(id);
    console.log("mmm", communityCtx?.members);
    console.log("me : ", me?.memberRole);
    console.log("user : ", me?.user);
  }, [id]);
  return (
    <>
      {/* {promoteMember !== null && (
        <RoleAssignPopup
          member={communityCtx?.members}
          onPromoted={props?.onRefresh}
          context={fakeChatCtx}
					community
        />
      )} */}
      <ModalRoleAssign
        member={communityCtx?.members}
        onPromoted={props?.onRefresh}
        context={fakeChatCtx}
        visible={promoteMember !== null}
      />
      <div className={styles.container} style={{ overflow: "hidden !important" }}>
        <div className={styles.SearchHeader}>
          <div
            className={styles.backIcon}
            style={{ backgroundImage: `url(${backIcon})` }}
            onClick={handleBack}
          />
          <div className={styles.searchContainer}>
            <div
              className={styles.searchIcon}
              style={{
                backgroundImage: `url(${requestIcon.searchIcon})`,
              }}
            />
            <input
              type="text"
              className={styles.searchInput}
              onChange={handleSearchMembers}
              placeholder={t("Search")}
              value={search}
            />
          </div>
          <div className={styles.inviteButton}>
            <CenterButton onClick={handleInvite}>
              {t("Invite")}
            </CenterButton>
          </div>
        </div>
        {/* <MyCenterMenuLayout> */}
        <Tabs tabBarExtraContent={<div style={{ margin: "auto 0px 0px auto" }}>
          {/* Owner */}
          {me?.memberRole === "owner" &&
            myProfile.id === me?.user.id ? (
            <div>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.owner);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Promote Owner")}
                        </div>
                      </div>
                    </Menu.Item>
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.admin);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Promote Admin")}
                        </div>
                      </div>
                    </Menu.Item>
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeAdmin);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove Admin")}
                        </div>
                      </div>
                    </Menu.Item>
                    {/* <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeOwner);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove Owner")}
                        </div>
                      </div>
                    </Menu.Item> */}
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeFromGroup);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove User")}
                        </div>
                      </div>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottomRight"
                arrow
                trigger={["click"]}
              >
                <img src={settingImg} width="20" style={{ cursor: "pointer" }} />
              </Dropdown>
            </div>
          ) : null}
          {/* Admin */}
          {me?.memberRole === "admin" &&
            myProfile.id === me?.user.id ? (
            <div>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      className={styles.menuItem}
                      onClick={() => {
                        handlePromoteMember(promoteRole.removeMember);
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            margin: "auto",
                          }}
                        >
                          {t("Remove Member")}
                        </div>
                      </div>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottomRight"
                arrow
                trigger={["click"]}
              >
                <img src={settingImg} width="20" style={{ cursor: "pointer" }} />
              </Dropdown>
            </div>
          ) : null}
        </div>}>
          <TabPane tab={t("Member") + ` (${communityCtx?.members?.length})`} key="group-requests">
            <div className={styles.memberListContainer}>
              {search === "" ?
                <Member
                  role={me?.memberRole}
                  data={me?.user}
                  isGroup={true}
                  context={fakeChatCtx}
                  community
                /> : null
              }
              {search === ""
                ? memberFilter?.map((member: any, idx: number) => {
                  return (
                    <Member
                      key={idx}
                      role={member?.memberRole}
                      data={member.user}
                      isGroup={true}
                      context={fakeChatCtx}
                      community
                    />
                  );
                }) : searchedMember.map((member: any, idx: number) => {
                  return (
                    <Member
                      key={idx}
                      role={member?.memberRole}
                      data={member.user}
                      isGroup={true}
                      context={fakeChatCtx}
                      community
                    />
                  );
                })}
            </div>

          </TabPane>
          <TabPane tab={"Group requests" + ` (${groupPendingRequests.length})`}>
            {groupPendingRequests.map((member: any) => {
              return (
                <List
                  className="demo-loadmore-list"
                  loading={loading}
                  itemLayout="horizontal"
                  // loadMore={loadMore}
                  style={{ backgroundColor: "white" }}
                  dataSource={groupPendingRequests}
                  renderItem={(member: any) => (
                    <List.Item style={{ borderBottom: "none", paddingTop: 0 }}>
                      <Skeleton avatar title={false} loading={false} active><GroupPending
                        id={member?.id}
                        imgURL={member?.user?.imageProfileURL}
                        name={member?.user?.firstname}
                        date={member?.user?.updatedAt}
                        onDecline={onDecline}
                        onAccept={onAccept} />
                      </Skeleton>
                    </List.Item>
                  )}
                />
              )
            })}

          </TabPane>
        </Tabs>

      </div>
    </>
  );
};

export default CommunityMemberManage;
